export const BASEURL = "http://www.duzikai.com/";
// export const BASEURL = "api/";
export const TIMEOUT = 60000;
